
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ke0mx", function(module, exports) {

$parcel$export(module.exports, "manifest", () => $8b2ff5afb7b4d3e5$export$e538f94cc8cf4db8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $63PsS = parcelRequire("63PsS");

var $hlhtG = parcelRequire("hlhtG");

var $4FhhO = parcelRequire("4FhhO");

var $bYRk6 = parcelRequire("bYRk6");

var $d7ZU3 = parcelRequire("d7ZU3");

var $cYYWV = parcelRequire("cYYWV");

var $4XKEZ = parcelRequire("4XKEZ");

var $9pBtT = parcelRequire("9pBtT");

var $2crjJ = parcelRequire("2crjJ");
// as const so that values can be looked up for i18n in ./ui/messages/keywords
const $8b2ff5afb7b4d3e5$var$JIRA_KEYWORDS = [
    'create',
    'issue',
    'ticket',
    'raise',
    'new'
];
const $8b2ff5afb7b4d3e5$var$CONFLUENCE_KEYWORDS = [
    'create',
    'page',
    'new',
    'space',
    'publish'
];
// categories will put us into tabs in the quick insert browser (the plus menu)
const $8b2ff5afb7b4d3e5$var$JIRA_CATEGORIES = [
    'development',
    'external-content'
];
const $8b2ff5afb7b4d3e5$var$CONFLUENCE_CATEGORIES = [
    'confluence-content'
];



const $8b2ff5afb7b4d3e5$export$e538f94cc8cf4db8 = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, analyticsContext: analyticsContext, location: location, gatewayBaseUrl: gatewayBaseUrl, flags: flags, defaultFormValues: defaultFormValues, pageContext: pageContext, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>{
    const formatMessage = (descriptor)=>{
        return intl?.formatMessage(descriptor) ?? descriptor.defaultMessage;
    };
    return {
        title: 'Link create editor extension',
        type: 'extension',
        key: 'com.atlassian.linking-platform.create',
        description: 'Configures quick insert commands for creating objects, like Jira issues and Confluence pages as links',
        icons: {
            '48': ()=>(parcelRequire("dfJYa")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'linking-platform-create-jira-issue',
                    title: formatMessage((0, $4XKEZ.jiraExtensionMessages).extensionTitle),
                    description: formatMessage((0, $4XKEZ.jiraExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8b2ff5afb7b4d3e5$var$JIRA_CATEGORIES,
                    keywords: [
                        'jira',
                        ...$8b2ff5afb7b4d3e5$var$JIRA_KEYWORDS.map((keyword)=>formatMessage((0, $4XKEZ.keywords)[keyword]))
                    ],
                    icon: ()=>(parcelRequire("dfJYa")).then((mod)=>mod.default),
                    action: async ()=>$8b2ff5afb7b4d3e5$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'jira-issue',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues
                        })
                },
                {
                    key: 'linking-platform-create-confluence-page',
                    title: formatMessage((0, $4XKEZ.confluenceExtensionMessages).extensionTitle),
                    description: formatMessage((0, $4XKEZ.confluenceExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8b2ff5afb7b4d3e5$var$CONFLUENCE_CATEGORIES,
                    keywords: [
                        'confluence',
                        ...$8b2ff5afb7b4d3e5$var$CONFLUENCE_KEYWORDS.map((keyword)=>formatMessage((0, $4XKEZ.keywords)[keyword]))
                    ],
                    icon: ()=>(parcelRequire("6V9Zi")).then((mod)=>mod.default),
                    action: async ()=>{
                        // Only do one step page creation experiment if we are
                        // 1. in the full page editor of a confluence page
                        // 2. it is not live edit or a blogpost
                        // 3. user is not using Safari
                        const shouldRunOneStepCreateExperiment = location === 'confluence-page' && pageContext?.isFullPageEditor && !pageContext?.isLivePage && !pageContext?.isBlogpost && !(0, $d7ZU3.browser).safari;
                        if (shouldRunOneStepCreateExperiment) {
                            const { isInlineCreateOneStepExperimentEnabled: isInlineCreateOneStepExperimentEnabled, cohort: cohort } = (0, $2crjJ.getInlineCreateOneStepExperimentEnabled)({
                                shouldFireExperimentExposure: true
                            });
                            if (isInlineCreateOneStepExperimentEnabled) return $8b2ff5afb7b4d3e5$var$oneStepCreate({
                                intl: intl,
                                intlLocale: intlLocale,
                                defaultCloudId: defaultCloudId,
                                analyticsContext: analyticsContext,
                                gatewayBaseUrl: gatewayBaseUrl,
                                flags: flags,
                                defaultFormValues: defaultFormValues,
                                cohort: cohort
                            });
                        }
                        return $8b2ff5afb7b4d3e5$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'confluence-page',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues,
                            allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                        });
                    }
                }
            ]
        }
    };
};
const $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE = 'en';
const $8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID = 'link-create-mount-point';
const $8b2ff5afb7b4d3e5$var$getMountPoint = ()=>{
    let modalEl = document.getElementById(`${$8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID}`);
    if (modalEl === null) {
        modalEl = document.createElement('div');
        modalEl.id = $8b2ff5afb7b4d3e5$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID;
        document.body.appendChild(modalEl);
    }
    return modalEl;
};
const $8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper = ({ children: children, value: value })=>{
    if (value === undefined) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cYYWV.LinkCreateModalProvider), {
        value: value,
        children: children
    });
};

const $8b2ff5afb7b4d3e5$var$LazyEditorExtensionLinkCreate = (0, $63PsS.lazy)(()=>(parcelRequire("dqnor")).then(({ EditorExtensionLinkCreate: EditorExtensionLinkCreate })=>({
            default: EditorExtensionLinkCreate
        })));

const $8b2ff5afb7b4d3e5$var$LazyOneStepLinkCreate = (0, $63PsS.lazy)(()=>(parcelRequire("bg4y8")).then(({ OneStepLinkCreate: OneStepLinkCreate })=>({
            default: OneStepLinkCreate
        })));
/*
 * Rather than rendering a modal and requesting user input, this function
 * creates a new page and immediately inserts it without any user input.
 * The title is generated on the backend so the new page is just created
 * and inserted as a smartlink. This is part of the Confluence Inline Create
 * One Step experiment.
 */ const $8b2ff5afb7b4d3e5$var$oneStepCreate = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, gatewayBaseUrl: gatewayBaseUrl, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues, cohort: cohort })=>{
    return new Promise(async (res)=>{
        const mountPoint = $8b2ff5afb7b4d3e5$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
            // For experiment variant 2, we want to open the draft in a new tab and show the success flag
            if (cohort === (0, $2crjJ.INLINE_CREATE_ONE_STEP_COHORTS).VARIANT2) {
                const parentId = defaultFormValues?.['confluence-page']?.parentId ?? '';
                window.name = parentId;
                // createdFrom param indicates to the new draft window to show a success flag on load
                const url = new URL(payload.url);
                url.searchParams.set('createdFrom', parentId);
                window.open(url, '_blank');
            }
        };
        const handleComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).render(/*#__PURE__*/ (0, $7UHDa.jsx)($8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
                messages: intl?.messages ?? {},
                locale: intl?.locale ?? intlLocale ?? 'en',
                defaultLocale: $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE,
                onError: intl?.onError,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
                    data: {
                        source: 'inlineCreateOneStep',
                        attributes: {
                            component: 'editorExtensionLinkCreate',
                            location: 'confluence-page',
                            triggeredFrom: 'quick-insert',
                            experiment: 'ConfluenceInlineCreateOneStepExperiment'
                        }
                    },
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9pBtT.ErrorBoundary), {
                        flags: flags,
                        onError: ()=>{
                            /**
             * If something goes wrong, resolve the promise to editor,
             * and unmount the component mountpoint
             */ res();
                            handleComplete();
                        },
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $63PsS.LazySuspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($8b2ff5afb7b4d3e5$var$LazyOneStepLinkCreate, {
                                onCreate: handleCreate,
                                gatewayBaseUrl: gatewayBaseUrl,
                                defaultCloudId: defaultCloudId,
                                defaultFormValues: defaultFormValues
                            })
                        })
                    })
                })
            })
        }), mountPoint);
    });
};
const $8b2ff5afb7b4d3e5$var$showCreateModal = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, entityKey: entityKey, gatewayBaseUrl: gatewayBaseUrl, location: location, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>new Promise(async (res)=>{
        const mountPoint = $8b2ff5afb7b4d3e5$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
        };
        const handleCancel = ()=>{
            res();
        };
        const handleCloseComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).render(/*#__PURE__*/ (0, $7UHDa.jsx)($8b2ff5afb7b4d3e5$var$AnalyticsProviderWrapper, {
            value: analyticsContext,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
                messages: intl?.messages ?? {},
                locale: intl?.locale ?? intlLocale ?? 'en',
                defaultLocale: $8b2ff5afb7b4d3e5$var$DEFAULT_LOCALE,
                onError: intl?.onError,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
                    data: {
                        attributes: {
                            component: 'editorExtensionLinkCreate',
                            location: location,
                            triggeredFrom: 'quick-insert'
                        }
                    },
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9pBtT.ErrorBoundary), {
                        flags: flags,
                        onError: ()=>{
                            /**
           * If something goes wrong, resolve the promise to editor,
           * and unmount the component mountpoint
           */ res();
                            handleCloseComplete();
                        },
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $63PsS.LazySuspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)($8b2ff5afb7b4d3e5$var$LazyEditorExtensionLinkCreate, {
                                defaultCloudId: defaultCloudId,
                                gatewayBaseUrl: gatewayBaseUrl,
                                defaultFormValues: defaultFormValues,
                                entityKey: entityKey,
                                onCreate: handleCreate,
                                onCancel: handleCancel,
                                onCloseComplete: handleCloseComplete,
                                flags: flags,
                                allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                            })
                        })
                    })
                })
            })
        }), mountPoint);
    });

});
parcelRegister("cYYWV", function(module, exports) {

$parcel$export(module.exports, "LinkCreateModalProvider", () => $71e94db7c7ca5154$export$9e8ad10df3086be2);

var $7UHDa = parcelRequire("7UHDa");

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $1M56W = parcelRequire("1M56W");
const $71e94db7c7ca5154$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
class $71e94db7c7ca5154$export$9e8ad10df3086be2 extends (0, $gwFzn.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1M56W.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.contextValue = void 0;
        this.getChildContext = ()=>{
            return this.contextValue;
        };
        const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext, getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers } = this.props.value;
        this.contextValue = {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }
}
$71e94db7c7ca5154$export$9e8ad10df3086be2.contextTypes = $71e94db7c7ca5154$var$ContextTypes;
$71e94db7c7ca5154$export$9e8ad10df3086be2.childContextTypes = $71e94db7c7ca5154$var$ContextTypes;

});

parcelRegister("4XKEZ", function(module, exports) {

$parcel$export(module.exports, "keywords", () => $822de4fa2e7d82c6$export$eebaaf2b24d91f63);
$parcel$export(module.exports, "jiraExtensionMessages", () => $822de4fa2e7d82c6$export$1578873c8519570a);
$parcel$export(module.exports, "confluenceExtensionMessages", () => $822de4fa2e7d82c6$export$5d64ddc7566152fc);
$parcel$export(module.exports, "jiraIssueMessages", () => $822de4fa2e7d82c6$export$52fbd4579940dbd3);
$parcel$export(module.exports, "confluencePageMessages", () => $822de4fa2e7d82c6$export$87a972c4338ba7c0);

var $2nPZH = parcelRequire("2nPZH");
const $822de4fa2e7d82c6$export$eebaaf2b24d91f63 = (0, $2nPZH.defineMessages)({
    create: {
        id: "editorExtensionLinkCreate.keyword.create",
        defaultMessage: "create"
    },
    issue: {
        id: "editorExtensionLinkCreate.keyword.issue",
        defaultMessage: "issue"
    },
    ticket: {
        id: "editorExtensionLinkCreate.keyword.ticket",
        defaultMessage: "ticket"
    },
    raise: {
        id: "editorExtensionLinkCreate.keyword.raise",
        defaultMessage: "raise"
    },
    new: {
        id: "editorExtensionLinkCreate.keyword.new",
        defaultMessage: "new"
    },
    space: {
        id: "editorExtensionLinkCreate.keyword.space",
        defaultMessage: "space"
    },
    publish: {
        id: "editorExtensionLinkCreate.keyword.publish",
        defaultMessage: "publish"
    },
    page: {
        id: "editorExtensionLinkCreate.keyword.page",
        defaultMessage: "page"
    }
});
const $822de4fa2e7d82c6$export$1578873c8519570a = (0, $2nPZH.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title",
        defaultMessage: "Create Jira issue"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description",
        defaultMessage: "Create an issue inline and insert the issue as a link"
    }
});
const $822de4fa2e7d82c6$export$5d64ddc7566152fc = (0, $2nPZH.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.title",
        defaultMessage: "Create Confluence page"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.description",
        defaultMessage: "Create a new page and insert it as a link"
    }
});
const $822de4fa2e7d82c6$export$52fbd4579940dbd3 = (0, $2nPZH.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.jiraIssue.title",
        defaultMessage: "Create new issue"
    },
    successFlagTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.title",
        defaultMessage: "Issue created"
    },
    successFlagDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.description",
        defaultMessage: "Your issue has been created"
    },
    successFlagActionOpen: {
        id: "editorExtensionLinkCreate.jiraIssue.successFlag.action.open",
        defaultMessage: "Open in Jira"
    }
});
const $822de4fa2e7d82c6$export$87a972c4338ba7c0 = (0, $2nPZH.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.confluencePage.title",
        defaultMessage: "Create new page"
    },
    newDraftTitle: {
        id: "editorExtensionLinkCreate.confluencePage.newDraftTitle",
        defaultMessage: "Untitled page"
    },
    successFlagTitle: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.title",
        defaultMessage: "Page created"
    },
    successFlagDescription: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.description",
        defaultMessage: "Your page has been created"
    },
    successFlagActionOpen: {
        id: "editorExtensionLinkCreate.confluencePage.successFlag.action.open",
        defaultMessage: "Open in Confluence"
    }
});

});

parcelRegister("9pBtT", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $8d3a3fbbacd63515$export$e926676385687eaf);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $hdKel = parcelRequire("hdKel");

var $ebpq7 = parcelRequire("ebpq7");

var $krp7k = parcelRequire("krp7k");

var $eZpnB = parcelRequire("eZpnB");
const $8d3a3fbbacd63515$var$NullFallback = ()=>null;
const $8d3a3fbbacd63515$var$getErrorType = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $8d3a3fbbacd63515$export$e926676385687eaf = ({ flags: flags, children: children, onError: onError })=>{
    const { fireEvent: fireEvent } = (0, $ebpq7.useAnalyticsEvents)();
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $krp7k.BaseErrorBoundary), {
        errorComponent: /*#__PURE__*/ (0, $7UHDa.jsx)($8d3a3fbbacd63515$var$NullFallback, {}),
        onError: (error)=>{
            // Capture exception to Sentry
            if (error instanceof Error) (0, $hdKel.captureException)(error, 'editor-extension-link-create');
            flags?.showFailure?.({
                title: intl.formatMessage((0, $eZpnB.messages).title),
                description: intl.formatMessage((0, $eZpnB.messages).description)
            });
            fireEvent('operational.editorExtensionLinkCreateExperience.failed', {
                errorType: $8d3a3fbbacd63515$var$getErrorType(error)
            });
            onError?.();
        },
        children: children
    });
};

});
parcelRegister("ebpq7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $76d4605a9bf2a846$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::ec329f21e6a5f943251e1d4a495988fb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $gw7I8 = parcelRequire("gw7I8");

var $d5rV1 = parcelRequire("d5rV1");
const $76d4605a9bf2a846$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $gwFzn.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $d5rV1.default)(...params));
        event.fire((0, $gw7I8.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("gw7I8", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $0e4ab8979da74ddc$export$3f072f06b90c3985);
const $0e4ab8979da74ddc$export$3f072f06b90c3985 = 'media';

});

parcelRegister("d5rV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $06f66ac78f70af1b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::34a5c56e53d2f2c68cac8363edc2b0d0>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ const $06f66ac78f70af1b$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $06f66ac78f70af1b$export$2e2bcd8739ae039 = $06f66ac78f70af1b$var$createEventPayload;

});


parcelRegister("krp7k", function(module, exports) {

$parcel$export(module.exports, "BaseErrorBoundary", () => $d96537c513bf058f$export$688779ac61ee945f);

var $gwFzn = parcelRequire("gwFzn");
class $d96537c513bf058f$export$688779ac61ee945f extends (0, $gwFzn.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, errorComponent: errorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && errorComponent) return errorComponent;
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}

});

parcelRegister("eZpnB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e0f7e34e90ca9be$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $6e0f7e34e90ca9be$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.genericError.title",
        defaultMessage: "Something went wrong"
    },
    description: {
        id: "editorExtensionLinkCreate.genericError.description",
        defaultMessage: "Refresh the page and try again."
    }
});

});


parcelRegister("2crjJ", function(module, exports) {

$parcel$export(module.exports, "INLINE_CREATE_ONE_STEP_COHORTS", () => $314dd9b217c01f30$export$5e7108ca89df23a6);
$parcel$export(module.exports, "getInlineCreateOneStepExperimentEnabled", () => $314dd9b217c01f30$export$f7488bbe58aabdf8);
$parcel$export(module.exports, "OneStepLinkCreate", () => $314dd9b217c01f30$export$db00e85699adaeba);

var $gwFzn = parcelRequire("gwFzn");

var $c6GJD = parcelRequire("c6GJD");

var $dBxQj = parcelRequire("dBxQj");

var $6RHln = parcelRequire("6RHln");

var $ebpq7 = parcelRequire("ebpq7");
const $314dd9b217c01f30$export$d695c6ae6c4aebb9 = 'confluence_inline_create_one_step_experiment';
var $314dd9b217c01f30$export$5e7108ca89df23a6 = /*#__PURE__*/ function(INLINE_CREATE_ONE_STEP_COHORTS) {
    INLINE_CREATE_ONE_STEP_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    INLINE_CREATE_ONE_STEP_COHORTS["CONTROL"] = "control";
    INLINE_CREATE_ONE_STEP_COHORTS["VARIANT1"] = "variant1";
    INLINE_CREATE_ONE_STEP_COHORTS["VARIANT2"] = "variant2";
    return INLINE_CREATE_ONE_STEP_COHORTS;
}({});
const $314dd9b217c01f30$export$3d370c33621572df = 'cohort';
const $314dd9b217c01f30$export$f7488bbe58aabdf8 = ({ shouldFireExperimentExposure: shouldFireExperimentExposure = false })=>{
    //  Returns the cohort of the tenant: not-enrolled, control, or test
    const cohort = (0, $c6GJD.default).getExperimentValue($314dd9b217c01f30$export$d695c6ae6c4aebb9, $314dd9b217c01f30$export$3d370c33621572df, "not-enrolled", {
        fireExperimentExposure: shouldFireExperimentExposure
    });
    // Returns if the user should see the inline create one step experiment
    const isInlineCreateOneStepExperimentEnabled = cohort === "variant1" || cohort === "variant2";
    return {
        cohort: cohort,
        isInlineCreateOneStepExperimentEnabled: isInlineCreateOneStepExperimentEnabled
    };
};
const $314dd9b217c01f30$export$db00e85699adaeba = ({ onCreate: onCreate, defaultCloudId: defaultCloudId, gatewayBaseUrl: gatewayBaseUrl, defaultFormValues: defaultFormValues })=>{
    // Managing errors via state so that any asynchronous errors (like promise
    // rejections) bubble up to the ErrorBoundary correctly
    const [error, setError] = (0, $gwFzn.useState)(null);
    if (error) throw error;
    const intl = (0, $dBxQj.default)();
    const { fireEvent: fireEvent } = (0, $ebpq7.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $6RHln.createConfluenceDraft)({
            intl: intl,
            defaultCloudId: defaultCloudId,
            defaultFormValues: defaultFormValues,
            gatewayBaseUrl: gatewayBaseUrl,
            onCreate: onCreate,
            setError: setError,
            fireAnalyticsEvent: fireEvent
        });
    }, [
        intl,
        defaultCloudId,
        defaultFormValues,
        gatewayBaseUrl,
        onCreate,
        setError,
        fireEvent
    ]);
    return null;
};

});
parcelRegister("6RHln", function(module, exports) {

$parcel$export(module.exports, "createConfluenceDraft", () => $f5d766016b46798f$export$35a28ef15d43eade);

var $lKTS7 = parcelRequire("lKTS7");
var $8ECvV = parcelRequire("8ECvV");
var $9OaoM = parcelRequire("9OaoM");
var $dzEdV = parcelRequire("dzEdV");

var $4XKEZ = parcelRequire("4XKEZ");
const $f5d766016b46798f$export$35a28ef15d43eade = async ({ intl: intl, defaultCloudId: defaultCloudId, defaultFormValues: defaultFormValues, gatewayBaseUrl: gatewayBaseUrl, onCreate: onCreate, setError: setError, fireAnalyticsEvent: fireAnalyticsEvent })=>{
    const siteUrl = window.location.origin;
    const defaultParentId = defaultFormValues?.['confluence-page']?.parentId;
    const defaultSpaceId = defaultFormValues?.['confluence-page']?.spaceId;
    try {
        const pageInfo = await (0, $9OaoM.fetchDefaultValues)(intl, defaultCloudId, gatewayBaseUrl, defaultSpaceId, defaultParentId);
        const spaceId = pageInfo?.value?.spaceId;
        // if there is no space id, we cannot create the page -
        // throw an error to show the error flag
        if (!spaceId) throw new Error('No spaceId found');
        const pageSuccessResponse = await (0, $8ECvV.createConfluencePage)({
            // As we are creating a draft, we always want to default
            // the title to (localized) 'Untitled page'
            title: intl.formatMessage((0, $4XKEZ.confluencePageMessages).newDraftTitle),
            spaceId: spaceId,
            parentId: defaultParentId,
            cloudId: defaultCloudId,
            gatewayBaseUrl: gatewayBaseUrl,
            status: 'draft',
            fireAnalyticsEvent: fireAnalyticsEvent,
            creationFlow: 'inline'
        });
        const url = (0, $dzEdV.getURLFromConfluencePageResponse)({
            data: pageSuccessResponse,
            hostname: siteUrl
        });
        onCreate({
            url: url,
            objectId: pageSuccessResponse.id,
            objectType: (0, $lKTS7.ContentTypes).PAGE
        });
        fireAnalyticsEvent('track.object.created', {
            source: 'inlineCreateOneStepExperiment',
            objectName: 'confluence-page' // One step create is only used for confluence pages
        });
    } catch (err) {
        setError(err);
    }
};

});
parcelRegister("lKTS7", function(module, exports) {

$parcel$export(module.exports, "entityKeys", () => $5f476fe4c48782bf$export$be0551febfd6121e);
$parcel$export(module.exports, "ContentTypes", () => $5f476fe4c48782bf$export$b9e669a853ca2f38);
$parcel$export(module.exports, "Fields", () => $5f476fe4c48782bf$export$833b3e5a19fb8939);
$parcel$export(module.exports, "testIds", () => $5f476fe4c48782bf$export$800daf5fbbe96aff);
$parcel$export(module.exports, "CONFLUENCE_EVENT_NAME", () => $5f476fe4c48782bf$export$c312550dc4e28902);
const $5f476fe4c48782bf$export$be0551febfd6121e = {
    confluencePage: 'confluence-page',
    confluenceWhiteboard: 'confluence-whiteboard'
};
const $5f476fe4c48782bf$export$b9e669a853ca2f38 = {
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
var $5f476fe4c48782bf$export$833b3e5a19fb8939 = /*#__PURE__*/ function(Fields) {
    Fields["Title"] = "title";
    Fields["Site"] = "site";
    Fields["SpacePage"] = "space_or_page";
    return Fields;
}({});
const $5f476fe4c48782bf$export$800daf5fbbe96aff = {
    form: 'link-create-confluence-form',
    title: 'link-create-confluence-title',
    site: 'link-create-confluence-site-picker',
    space: 'link-create-confluence-space-picker',
    error: 'link-create-confluence-form-error'
};
const $5f476fe4c48782bf$export$c312550dc4e28902 = {
    EDIT_PAGE: 'edit-page',
    EDIT_PAGE_LOAD: 'edit-page/load',
    EDIT_PAGE_PUBLISH: 'edit-page/publish',
    EDIT_PAGE_CLOSE: 'edit-page/close'
};

});

parcelRegister("8ECvV", function(module, exports) {

$parcel$export(module.exports, "createConfluencePage", () => $e523a7108465f12e$export$6369b3eb182e172e);

var $92sd0 = parcelRequire("92sd0");

var $dzEdV = parcelRequire("dzEdV");
const $e523a7108465f12e$export$6369b3eb182e172e = async ({ title: title, spaceId: spaceId, parentId: parentId, cloudId: cloudId, gatewayBaseUrl: gatewayBaseUrl = '', pageBody: pageBody = '', status: status = 'current', representation: representation = 'storage', subtype: subtype, fireAnalyticsEvent: fireAnalyticsEvent, creationFlow: creationFlow })=>{
    /** API docs at
	 * https://developer.atlassian.com/cloud/confluence/rest/v2/api-group-page/#api-pages-post
	 */ const response = await fetch((0, $dzEdV.getCreateConfluencePageURL)({
        cloudId: cloudId,
        gatewayBaseUrl: gatewayBaseUrl
    }), {
        method: 'post',
        credentials: 'include',
        headers: {
            accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            status: status,
            title: title,
            spaceId: spaceId,
            ...parentId && {
                parentId: parentId
            },
            body: {
                representation: representation,
                value: pageBody
            },
            ...subtype && {
                subtype: subtype
            }
        })
    });
    if (!response.ok) switch(response.status){
        case 404:
            throw new (0, $92sd0.UserPermissionError)('The user does not have the required permission for this action.');
        // 400 is a catch-all error from the Create Page API
        case 400:
            let errorMessage = '';
            try {
                // note: response can only be consumed once
                errorMessage = (await response.json()).errors?.[0]?.title;
            } catch (error) {}
            if (errorMessage.includes('Error converting ADF to storage format')) throw new (0, $92sd0.ADFConversionError)('Error converting ADF to storage format');
            // Invalid Content type
            throw new (0, $92sd0.PageTitleError)('A page with this title already exists');
        default:
            throw response;
    }
    else fireAnalyticsEvent?.('track.content.createdByFlow', {
        flow: `linkCreateConfluence-${creationFlow}`,
        contentType: 'page',
        isLivePage: subtype === 'live',
        collabService: 'ncs'
    });
    return response.json();
};

});
parcelRegister("92sd0", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $1863b5aa53e4c100$export$e19f9f08a6d79fd2);
$parcel$export(module.exports, "UserPermissionError", () => $1863b5aa53e4c100$export$49b74be15efcd36c);
$parcel$export(module.exports, "NotFoundError", () => $1863b5aa53e4c100$export$78c95b58762d2106);
$parcel$export(module.exports, "PageTitleError", () => $1863b5aa53e4c100$export$62045d6b8fc54a79);
$parcel$export(module.exports, "TemplateError", () => $1863b5aa53e4c100$export$60d92bc45fae76c8);
$parcel$export(module.exports, "WhiteboardDuplicateTitleError", () => $1863b5aa53e4c100$export$3ab60a45f7d10b34);
$parcel$export(module.exports, "NoWhiteboardBetaAccessError", () => $1863b5aa53e4c100$export$fd870c5941ae9645);
$parcel$export(module.exports, "ContentTooLargeError", () => $1863b5aa53e4c100$export$6703e6b2271568b8);
$parcel$export(module.exports, "ADFConversionError", () => $1863b5aa53e4c100$export$c82efbc4aa781138);
const $1863b5aa53e4c100$export$4fd720569787ab6f = [
    'NO_CONFLUENCE_SITE_FOUND_ERROR',
    'COULD_NOT_FIND_CONFLUENCE_SITE_ERROR'
];
const $1863b5aa53e4c100$export$76161dc26c0ed920 = (str)=>{
    return $1863b5aa53e4c100$export$4fd720569787ab6f.includes(str);
};
const $1863b5aa53e4c100$export$e19f9f08a6d79fd2 = (error)=>{
    return error instanceof Error && $1863b5aa53e4c100$export$76161dc26c0ed920(error.name) ? error.name : 'UNEXPECTED_ERROR';
};
class $1863b5aa53e4c100$export$49b74be15efcd36c extends Error {
    constructor(description){
        super(description), this.description = description;
        this.name = 'UserPermissionError';
    }
}
class $1863b5aa53e4c100$export$78c95b58762d2106 extends Error {
    constructor(description){
        super(description), this.description = description;
        this.name = 'NotFoundError';
    }
}
class $1863b5aa53e4c100$export$62045d6b8fc54a79 extends Error {
    constructor(description){
        super('A page with this title already exists'), this.description = description;
        this.name = 'PageTitleError';
    }
}
class $1863b5aa53e4c100$export$60d92bc45fae76c8 extends Error {
    constructor(description){
        super('The template ID does not exist or the user has no permissions to view it'), this.description = description;
        this.name = 'TemplateError';
    }
}
class $1863b5aa53e4c100$export$3ab60a45f7d10b34 extends Error {
    constructor(description){
        super(description), this.description = description;
        this.name = 'WhiteboardDuplicateTitleError';
    }
}
class $1863b5aa53e4c100$export$fd870c5941ae9645 extends Error {
    constructor(description){
        super(description), this.description = description;
        this.name = 'NoWhiteboardBetaAccessError';
    }
}
class $1863b5aa53e4c100$export$6703e6b2271568b8 extends Error {
    constructor(description){
        super(description), this.description = description;
        this.name = 'ContentTooLargeError';
    }
}
class $1863b5aa53e4c100$export$c82efbc4aa781138 extends Error {
    constructor(description){
        super('Error converting ADF to storage format'), this.description = description;
        this.name = 'ADFConversionError';
    }
}

});

parcelRegister("dzEdV", function(module, exports) {

$parcel$export(module.exports, "getCreateConfluencePageURL", () => $c0443b5d1443c1fa$export$6b10645c415ccfb2);
$parcel$export(module.exports, "getURLFromConfluencePageResponse", () => $c0443b5d1443c1fa$export$e87b28852220b5cd);
const $c0443b5d1443c1fa$export$6b10645c415ccfb2 = ({ cloudId: cloudId, gatewayBaseUrl: gatewayBaseUrl = '' })=>`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/pages?${new URLSearchParams({
        expand: 'space'
    }).toString()}`;
const $c0443b5d1443c1fa$export$e87b28852220b5cd = ({ data: data, hostname: hostname })=>{
    if (data.errors) throw new Error(`Error creating confluence page: ${data.errors[0].title}`);
    // In case something went wrong but is not an error
    if (!data.id || !data.spaceId) throw new Error('Something went wrong...');
    let domain = '';
    if (typeof window.location !== 'undefined') domain = hostname ?? window.location.origin;
    //Create edit link if status is draft
    const pages = data.status === 'draft' ? 'pages/edit-v2' : 'pages';
    // Success:: build and return URL from the response data
    return `${domain}/wiki/spaces/${data.spaceId}/${pages}/${data.id}/`;
};

});


parcelRegister("9OaoM", function(module, exports) {

$parcel$export(module.exports, "fetchPageAndSpaceOptions", () => $5b430a6821a2c143$export$6b458a19dcad9471);
$parcel$export(module.exports, "fetchDefaultValues", () => $5b430a6821a2c143$export$484edd54e8ab8e9d);

var $dh538 = parcelRequire("dh538");

var $jUSbx = parcelRequire("jUSbx");

var $aP1pD = parcelRequire("aP1pD");

var $JCfda = parcelRequire("JCfda");

var $a6SQO = parcelRequire("a6SQO");

var $cYKIJ = parcelRequire("cYKIJ");
const $5b430a6821a2c143$var$mapPageOptions = (pageSearch)=>{
    return pageSearch?.results?.map(({ title: title, space: space, id: id, _links: _links, subType: subType })=>({
            label: title,
            value: {
                spaceId: `${space.id}`,
                spaceKey: space.key,
                spaceName: space.name,
                linkedPageId: id,
                linkedPageTitle: title,
                isPage: true,
                isLive: subType === 'live',
                spaceUrl: `${pageSearch._links.base}/spaces/${space.key}`,
                linkedPageUrl: `${pageSearch._links.base}${_links?.webui}`,
                isLivePagesEnabledForParentSpace: space.typeSettings?.enabledContentTypes?.isLivePagesEnabled
            }
        }));
};
const $5b430a6821a2c143$var$mapSpaceOptions = (spaceSearch)=>{
    return spaceSearch?.data?.search?.search?.edges?.map(({ node: node })=>({
            label: node.title,
            value: {
                spaceId: (0, $jUSbx.ConfluenceSpaceAri).parse(node.spaceEntity.id).spaceId,
                spaceKey: node.spaceEntity.key,
                spaceName: node.title,
                spaceUrl: `${node.spaceEntity.links.base}${node.spaceEntity.links.webUi}`,
                iconPath: `${node.spaceEntity.links.base}${node.spaceEntity.icon.path}`,
                isPage: false,
                isLivePagesEnabled: node.spaceEntity.typeSettings.enabledContentTypes.isLivePagesEnabled
            }
        }));
};
/*
 *  Remove when cleaning up link-create-search-confluence-spaces-gql feature gate, use mapPageAndSpaceOptionsV2 instead
 */ const $5b430a6821a2c143$var$mapPageAndSpaceOptions = (spaceSearch, pageSearch, intl)=>{
    const spaceOptions = spaceSearch?.scopes?.[0]?.results?.map(({ title: title, space: space, baseUrl: baseUrl, url: url, id: id })=>({
            label: title,
            value: {
                spaceId: id,
                spaceKey: space?.key,
                spaceName: title,
                spaceUrl: `${baseUrl}${url}`,
                iconPath: `${baseUrl}${space?.icon?.path}`,
                isPage: false
            }
        }));
    const pageOptions = $5b430a6821a2c143$var$mapPageOptions(pageSearch);
    return [
        {
            label: intl.formatMessage((0, $cYKIJ.messages).spacesOptionLabel),
            options: spaceOptions
        },
        {
            label: intl.formatMessage((0, $cYKIJ.messages).contentOptionLabel),
            options: pageOptions
        }
    ];
};
const $5b430a6821a2c143$var$mapPageAndSpaceOptionsV2 = (spaceSearch, pageSearch, intl, filterOptionsForLiveDocs)=>{
    const spaceOptions = $5b430a6821a2c143$var$mapSpaceOptions(spaceSearch);
    const pageOptions = $5b430a6821a2c143$var$mapPageOptions(pageSearch);
    return [
        {
            label: intl.formatMessage((0, $cYKIJ.messages).spacesOptionLabel),
            options: filterOptionsForLiveDocs && (0, $dh538.fg)('live_docs_button_issue_view_improvements') ? $5b430a6821a2c143$var$filterSpacesForLiveDocs(spaceOptions) : spaceOptions
        },
        {
            label: intl.formatMessage((0, $cYKIJ.messages).contentOptionLabel),
            options: filterOptionsForLiveDocs && (0, $dh538.fg)('live_docs_button_issue_view_improvements') ? $5b430a6821a2c143$var$filterParentPagesForLiveDocs(pageOptions) : pageOptions
        }
    ];
};
const $5b430a6821a2c143$var$SPACES_MAX_RESULTS = 5;
const $5b430a6821a2c143$export$6b458a19dcad9471 = async (inputValue, cloudId, gatewayBaseUrl = '', intl, filterOptionsForLiveDocs)=>{
    const pageSearch = await (0, $aP1pD.searchConfluencePages)({
        searchString: inputValue,
        cloudId: cloudId,
        gatewayBaseUrl: gatewayBaseUrl
    });
    let options;
    if ((0, $dh538.fg)('link-create-search-confluence-spaces-gql')) {
        let spaceSearch = await (0, $JCfda.searchConfluenceSpacesV2)({
            cloudId: cloudId,
            limit: $5b430a6821a2c143$var$SPACES_MAX_RESULTS,
            // Limit displayed spaces to give room for pages results
            searchString: inputValue,
            gatewayBaseUrl: gatewayBaseUrl
        });
        options = $5b430a6821a2c143$var$mapPageAndSpaceOptionsV2(spaceSearch, pageSearch, intl, filterOptionsForLiveDocs);
    } else {
        let spaceSearch = await (0, $JCfda.searchConfluenceSpaces)({
            cloudId: cloudId,
            limit: $5b430a6821a2c143$var$SPACES_MAX_RESULTS,
            // Limit displayed spaces to give room for pages results
            searchString: inputValue,
            gatewayBaseUrl: gatewayBaseUrl
        });
        options = $5b430a6821a2c143$var$mapPageAndSpaceOptions(spaceSearch, pageSearch, intl);
    }
    return options;
};
const $5b430a6821a2c143$export$e4edbe3191dc4a85 = (intl, spaceSearch, pageSearch, gatewayBaseUrl)=>{
    const spaceOption = spaceSearch && {
        label: spaceSearch.name,
        value: {
            isPage: false,
            spaceId: spaceSearch.id,
            spaceKey: spaceSearch.key,
            spaceName: spaceSearch.name,
            iconPath: `${(0, $a6SQO.removeTrailingSlash)(gatewayBaseUrl)}${spaceSearch.icon?.path}`,
            spaceUrl: `${(0, $a6SQO.removeTrailingSlash)(gatewayBaseUrl)}${spaceSearch._links?.webui}`
        }
    };
    const isPageAndSpaceRelated = pageSearch?.spaceId === spaceSearch?.id;
    const pageOption = pageSearch && {
        label: pageSearch.title || intl.formatMessage((0, $cYKIJ.messages).pageUntitledDraft),
        value: {
            isPage: true,
            isLive: pageSearch.subtype === 'live',
            spaceId: pageSearch.spaceId,
            spaceKey: isPageAndSpaceRelated && spaceSearch ? spaceSearch.key : '',
            spaceName: isPageAndSpaceRelated && spaceSearch ? spaceSearch.name : '',
            linkedPageId: pageSearch.id,
            linkedPageTitle: pageSearch.title,
            spaceUrl: isPageAndSpaceRelated && spaceSearch ? `${(0, $a6SQO.removeTrailingSlash)(gatewayBaseUrl)}${spaceSearch?._links?.webui}` : '',
            linkedPageUrl: ''
        }
    };
    /**
   * returns pageOption first as it has a higher specificity than spaceOption
   */ return pageOption ?? spaceOption;
};
const $5b430a6821a2c143$export$484edd54e8ab8e9d = async (intl, cloudId, gatewayBaseUrl = '', defaultSpaceId, defaultParentId, onFailure)=>{
    let pageSearch;
    let spaceSearch;
    if (defaultSpaceId) spaceSearch = (0, $JCfda.searchConfluenceSpace)({
        cloudId: cloudId,
        gatewayBaseUrl: gatewayBaseUrl,
        defaultSpaceId: defaultSpaceId
    });
    if (defaultParentId) pageSearch = (0, $aP1pD.searchConfluencePage)({
        cloudId: cloudId,
        gatewayBaseUrl: gatewayBaseUrl,
        defaultParentId: defaultParentId
    });
    const responses = await Promise.allSettled([
        spaceSearch,
        pageSearch
    ]);
    responses.forEach((res)=>{
        if (res.status === 'rejected') onFailure?.(res.reason);
    });
    const [page, space] = responses;
    return $5b430a6821a2c143$export$e4edbe3191dc4a85(intl, page.status === 'fulfilled' ? page.value : undefined, space.status === 'fulfilled' ? space.value : undefined, gatewayBaseUrl);
};
/**
 * Customers should only be able to create live docs in spaces which have live docs enabled.
 * This function filters out any spaces which do not have live docs enabled.
 */ const $5b430a6821a2c143$var$filterSpacesForLiveDocs = (options)=>{
    return options.filter((option)=>option.value.isLivePagesEnabled);
};
/**
 * Customers should only be able to create live docs in spaces which have live docs enabled.
 * This function filters out any pages which are located in spaces without live docs enabled.
 */ const $5b430a6821a2c143$var$filterParentPagesForLiveDocs = (options)=>{
    return options.filter((option)=>option.value.isLivePagesEnabledForParentSpace);
};

});
parcelRegister("aP1pD", function(module, exports) {

$parcel$export(module.exports, "searchConfluencePages", () => $e037ff98607aa644$export$b7c915cfba7db283);
$parcel$export(module.exports, "searchConfluencePage", () => $e037ff98607aa644$export$4f72139b16008675);

var $a6SQO = parcelRequire("a6SQO");

var $9Il5x = parcelRequire("9Il5x");
const $e037ff98607aa644$var$IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';
const $e037ff98607aa644$export$b7c915cfba7db283 = async ({ searchString: searchString, cloudId: cloudId, gatewayBaseUrl: gatewayBaseUrl = '' })=>{
    let cqlQuery;
    if (searchString) cqlQuery = `type=page and title ~ "${(0, $a6SQO.sanitizeInput)(searchString)}"`;
    else cqlQuery = `type=page`;
    const response = await fetch((0, $9Il5x.getConfluencePageSearchURL)({
        cqlQuery: cqlQuery,
        cloudId: cloudId,
        gatewayBaseUrl: gatewayBaseUrl
    }), {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            [$e037ff98607aa644$var$IGNORE_MAU_HEADER]: 'true'
        }
    });
    if (!response.ok) throw response;
    return response.json();
};
const $e037ff98607aa644$export$4f72139b16008675 = async ({ cloudId: cloudId, defaultParentId: defaultParentId, gatewayBaseUrl: gatewayBaseUrl = '' })=>{
    const response = await fetch(`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/pages/${defaultParentId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw response;
    return response.json();
};

});
parcelRegister("a6SQO", function(module, exports) {

$parcel$export(module.exports, "removeTrailingSlash", () => $d08e018761c2f85a$export$b6d465111d914331);
$parcel$export(module.exports, "sanitizeInput", () => $d08e018761c2f85a$export$d529ba4b6bdbcf0c);
$parcel$export(module.exports, "confluencePageAri", () => $d08e018761c2f85a$export$ca5b38175ca9efca);
const $d08e018761c2f85a$export$b6d465111d914331 = (url = '')=>url.replace(/\/$/, '');
function $d08e018761c2f85a$export$d529ba4b6bdbcf0c(input = '') {
    // The double quotes don't need to be balanced, as the backend handles this fine (static String ensureBalancedDoubleQuotes(String str))
    return input.replace(/"|'|\*|~|\\/g, '\\$&');
}
function $d08e018761c2f85a$export$ca5b38175ca9efca({ cloudId: cloudId, resourceId: resourceId }) {
    return `ari:cloud:confluence:${cloudId}:page/${resourceId}`;
}

});

parcelRegister("9Il5x", function(module, exports) {

$parcel$export(module.exports, "getConfluencePageSearchURL", () => $a5b85d1bbd0dfe15$export$b71c51cebe3b5358);

var $dh538 = parcelRequire("dh538");
const $a5b85d1bbd0dfe15$export$b71c51cebe3b5358 = ({ cqlQuery: cqlQuery, cloudId: cloudId, gatewayBaseUrl: gatewayBaseUrl = '' })=>`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/search?${new URLSearchParams({
        cql: cqlQuery,
        expand: (0, $dh538.fg)('live_docs_button_issue_view_improvements') ? 'space.typeSettings,link' : 'space,link'
    }).toString()}`;

});


parcelRegister("JCfda", function(module, exports) {

$parcel$export(module.exports, "searchConfluenceSpaces", () => $23f83f66c944e322$export$dd2276d83e80b5ed);
$parcel$export(module.exports, "searchConfluenceSpacesV2", () => $23f83f66c944e322$export$e0fba3293874b624);
$parcel$export(module.exports, "searchConfluenceSpace", () => $23f83f66c944e322$export$1773d1c6fcf6f473);

var $a6SQO = parcelRequire("a6SQO");

var $fA7Rw = parcelRequire("fA7Rw");
const $23f83f66c944e322$var$CONFLUENCE_SPACE_SEARCH_URL = `/gateway/api/xpsearch-aggregator/quicksearch/v1`;
const $23f83f66c944e322$export$dd2276d83e80b5ed = async ({ searchString: searchString, cloudId: cloudId, limit: limit, gatewayBaseUrl: gatewayBaseUrl = '' })=>{
    const query = searchString ? (0, $a6SQO.sanitizeInput)(searchString) : '';
    const response = await fetch(`${gatewayBaseUrl}${$23f83f66c944e322$var$CONFLUENCE_SPACE_SEARCH_URL}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            cloudId: cloudId,
            limit: limit,
            scopes: [
                'confluence.space'
            ],
            experience: 'link-create.confluence-form'
        })
    });
    if (!response.ok) throw response;
    return response.json();
};
const $23f83f66c944e322$export$e0fba3293874b624 = async ({ searchString: searchString, cloudId: cloudId, limit: limit, gatewayBaseUrl: gatewayBaseUrl = '' })=>{
    const queryString = searchString ? (0, $a6SQO.sanitizeInput)(searchString) : '';
    const response = await fetch(`${gatewayBaseUrl}${(0, $fA7Rw.AGG_CONFLUENCE_SPACE_SEARCH_URL)}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: (0, $fA7Rw.getSearchConfluenceSpacesGraphqlPayload)({
            cloudId: cloudId,
            queryString: queryString,
            limit: limit
        })
    });
    if (!response.ok) throw response;
    return response.json();
};
const $23f83f66c944e322$export$1773d1c6fcf6f473 = async ({ cloudId: cloudId, defaultSpaceId: defaultSpaceId, gatewayBaseUrl: gatewayBaseUrl = '' })=>{
    const response = await fetch(`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/spaces/${defaultSpaceId}?${new URLSearchParams({
        expand: 'links',
        description: 'plain',
        'include-icon': 'true'
    }).toString()}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw response;
    return response.json();
};

});
parcelRegister("fA7Rw", function(module, exports) {

$parcel$export(module.exports, "AGG_CONFLUENCE_SPACE_SEARCH_URL", () => $0415650ec866477a$export$ba2d0706f6628ecf);
$parcel$export(module.exports, "getSearchConfluenceSpacesGraphqlPayload", () => $0415650ec866477a$export$72927c266f64c31d);
const $0415650ec866477a$export$ba2d0706f6628ecf = `/gateway/api/graphql`;
const $0415650ec866477a$export$72927c266f64c31d = ({ cloudId: cloudId, queryString: queryString, limit: limit })=>JSON.stringify({
        query: `query SearchConfluenceSpacesQuery {
			search {
			  search(
				experience: "link-create.confluence-form",
				query: "${queryString}",
				last: ${limit},
				filters: {
				  entities: "ati:cloud:confluence:space",
				  locations: "ari:cloud:confluence::site/${cloudId}"
				}) {
				edges {
				  node {
					title
					... on SearchConfluenceSpace {
					  spaceEntity {
						key
						alias
						id
						icon {
							path
						}
						links {
							base
							webUi
						}
						typeSettings {
							enabledContentTypes {
								isLivePagesEnabled
							}
						}
					  }
					}
				  }
				}
			  }
			}
		  }`,
        operationName: 'SearchConfluenceSpacesQuery'
    });

});


parcelRegister("cYKIJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $92ab0fc2eb8298ed$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $92ab0fc2eb8298ed$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    pageUntitledDraft: {
        id: "linkCreate.CreateConfluencePage.create.page.untitled.draft",
        defaultMessage: "Draft: Untitled"
    },
    contentOptionLabel: {
        id: "linkCreate.CreateConfluencePage.create.content.label",
        defaultMessage: "Content"
    },
    spacesOptionLabel: {
        id: "linkCreate.CreateConfluencePage.create.spaces.label",
        defaultMessage: "Spaces"
    }
});

});




parcelRegister("dfJYa", function(module, exports) {

let $9a6055a16e42490e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9a6055a16e42490e$var$load("kkycx"),
    $9a6055a16e42490e$var$load("hXu5I")
]).then(()=>parcelRequire('hlE0H'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("6V9Zi", function(module, exports) {

let $509fd048b8e4dbfa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $509fd048b8e4dbfa$var$load("esvqD"),
    $509fd048b8e4dbfa$var$load("7lyIx")
]).then(()=>parcelRequire('4XWss'));

});

parcelRegister("dqnor", function(module, exports) {

let $9c5fd9802bfc9278$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9c5fd9802bfc9278$var$load("a0oMZ").then(()=>parcelRequire('BkPha'));

});

parcelRegister("bg4y8", function(module, exports) {

let $8324b7cd8deb4091$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8324b7cd8deb4091$var$load("8KDBK").then(()=>parcelRequire('dQrBJ'));

});



//# sourceMappingURL=FullPageEditorComponent.691ddee7.js.map
